import type { FetcherContext } from './types.js';

export const selectRoomsForCurrentFloor = async (context: FetcherContext) => {
  const currentFloor = context.deps.currentFloor;
  const venueId = context.deps.venueId ?? null;

  const selectedFloor =
    currentFloor !== null && currentFloor !== '' ? parseInt(currentFloor, 10) : null;
  const filterByFloor = selectedFloor !== null && !Number.isNaN(selectedFloor);

  if (!venueId) {
    console.warn('No venue configured; cannot select rooms for current floor.');
    return { rooms: [], filterByFloor, selectedFloor };
  }

  if (!window.mapsindoors?.services?.LocationsService?.getLocations) {
    console.warn('MapsIndoors LocationsService.getLocations is not available.');
    return { rooms: [], filterByFloor, selectedFloor };
  }

  const types = ['Meeting Room', 'Private Workspace'];

  const locations = await window.mapsindoors.services.LocationsService.getLocations({
    venue: venueId,
    floor:
      filterByFloor && selectedFloor !== null && !Number.isNaN(selectedFloor)
        ? selectedFloor
        : null,
    types,
  });

  const rooms = locations;

  return { rooms, filterByFloor, selectedFloor };
};

export const selectRoomsOrWarn = async (context: FetcherContext) => {
  const selection = await selectRoomsForCurrentFloor(context);
  if (selection.filterByFloor && selection.rooms.length === 0) {
    console.warn(`No rooms found for floor ${selection.selectedFloor}. Skipping update.`);
    return null;
  }

  return selection.rooms;
};
